module.exports = __webpack_public_path__ + "static/img/banner_journey@2x.c80c448.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/journey/banner_journey@2x.png
// module id = zbrI
// module chunks = 1